import moment from 'moment';

/** Table / list display: MM/DD/YYYY h:mm am/pm */
export const SCHEDULE_DATETIME_DISPLAY = 'MM/DD/YYYY h:mm a';

/**
 * True for server/ISO values Jackson can deserialize.
 * Rejects table display strings like "06/15/2026 1:30 pm" or "2026-06-15 1:30 pm".
 */
export function isServerDateString(
  value: string | number | Date | null | undefined,
): boolean {
  if (value instanceof Date) {
    return !Number.isNaN(value.getTime());
  }
  if (typeof value === 'number') {
    return value > 0;
  }
  if (typeof value !== 'string' || !value) {
    return false;
  }
  return (
    /^\d{4}-\d{2}-\d{2}$/.test(value) ||
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/.test(
      value,
    )
  );
}

/** Prefer epoch ms when present; otherwise parse a server/ISO date string only. */
export function toEpochMs(
  ms: number | null | undefined,
  dateValue: string | number | Date | null | undefined,
): number | null {
  if (ms != null && ms > 0) {
    return ms;
  }
  if (dateValue == null || dateValue === '') {
    return null;
  }
  if (!isServerDateString(dateValue)) {
    return null;
  }
  const parsed = moment(dateValue).valueOf();
  return Number.isNaN(parsed) ? null : parsed;
}

/** Keep the clock time from `timeSourceMs` on the calendar day of `daySourceMs`. */
export function applyTimeOfDayMs(
  daySourceMs: number,
  timeSourceMs: number,
): number {
  const day = moment(daySourceMs);
  const time = moment(timeSourceMs);
  return day
    .clone()
    .hour(time.hour())
    .minute(time.minute())
    .second(0)
    .millisecond(0)
    .valueOf();
}

export function formatScheduleDateTime(
  ms: number | null | undefined,
  dateValue?: string | number | Date | null,
): string {
  const epoch = toEpochMs(ms, dateValue);
  if (epoch == null) {
    return '-';
  }
  return moment(epoch).format(SCHEDULE_DATETIME_DISPLAY);
}
